module.exports = __webpack_public_path__ + "assets/img/reset.f3a3b7cf.svg";